import Grid from "@mui/material/Grid";
import { getDetailPanelColumns, getDetailColumnValues } from "../util/seniorityListUtils";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  rowHeader: {
    paddingLeft: 0,
    marginLeft: 8,
    marginTop: 1,
  },
  rowValue: {
    paddingLeft: 0,
    marginLeft: 8,
  },
  data: { paddingLeft: 4 },
}));

const SeniorityListDetailPanelContent = ({ row: seniorityRow, contract, seniorityListType, station, workgroup }) => {
  const classes = useStyles();
  let detailPanelColumns = getDetailPanelColumns(contract, seniorityListType, station, workgroup);
  let detailPanelValues = getDetailColumnValues(detailPanelColumns, seniorityRow);

  return (
    <Stack direction="column">
      <Grid container className={classes.rowHeader} textAlign="left" justifyContent={"center"} spacing={2}>
        {detailPanelValues?.map((item) => (
          <Grid
            item
            key={item.title}
            xs={detailPanelValues?.length > 3 ? 3 : 4}
            sm={detailPanelValues?.length > 3 ? 3 : 4}
            className={classes.data}
          >
            <Typography fontSize="14px">{item.title}</Typography>
          </Grid>
        ))}
      </Grid>
      <Grid container className={classes.rowValue} textAlign="left" justifyContent={"center"} spacing={2}>
        {detailPanelValues?.map((item) => (
          <Grid
            item
            key={item.title}
            xs={detailPanelValues?.length > 3 ? 3 : 4}
            sm={detailPanelValues?.length > 3 ? 3 : 4}
            className={classes.data}
          >
            <Typography fontSize="14px" color="textSecondary">
              {item.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

SeniorityListDetailPanelContent.propTypes = {
  row: PropTypes.object.isRequired,
  contract: PropTypes.string.isRequired,
  seniorityListType: PropTypes.string.isRequired,
  station: PropTypes.string.isRequired,
  workgroup: PropTypes.string.isRequired,
};

export default SeniorityListDetailPanelContent;
